import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomCopyButton from "../../../../components/CustomCopyButton";
import { getHealthCommand } from "./utils";

const ExternalAPIKeyDisplayModal = ({
  open,
  handleClose,
  apiKey,
  backendURL,
}) => {
  const colors = useColors();
  const healthCommand = getHealthCommand(backendURL, apiKey);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>API Key Generated</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1">
            Your API key has been generated. Please copy and store it securely.
          </Typography>
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: colors.grey_200,
              borderRadius: "4px",
              wordBreak: "break-all",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">{apiKey}</Typography>
            <CustomCopyButton
              copyTitle="API Key"
              copyText={apiKey}
              sx={{ mt: 2 }}
            />
          </Box>

          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            To check the key, you can run the following command:
          </Typography>
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: colors.grey_200,
              borderRadius: "4px",
              wordBreak: "break-all",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">{healthCommand}</Typography>
            <CustomCopyButton copyTitle="command" copyText={healthCommand} />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalAPIKeyDisplayModal;
